module.exports = __webpack_public_path__ + "img/eclipse-front-angle.fda28c0f.png";